export function withName(template: string, name: string): string {
  return template.replace(/\{\{\s*name\s*\}\}/g, name);
}
